import React from "react";

import "./Spinner.scss";
function Spinner() {
    return (<div className="loader">Loading...</div>);
}

export default Spinner;